import { Shield, Code, Scale, Award } from "lucide-react";

const TeamCredibility = () => {
  return (
    <section className="py-24 px-8 bg-muted/30">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-foreground mb-4">
            Built by NCAA Compliance Veterans
          </h2>
          <p className="text-lg font-light text-muted-foreground max-w-[700px] mx-auto">
            Our founding team combines deep NCAA expertise with enterprise technology experience
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center fade-on-scroll">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Shield className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Division I Veterans</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Former compliance officers from SEC and Big Ten programs
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.15s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Scale className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Legal Expertise</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              NCAA Legal Affairs consultants and sports law attorneys
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.3s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Code className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Enterprise SaaS</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Architects from Workday and Salesforce compliance modules
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.45s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Award className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Security Engineers</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Security engineers with Big 4 audit and compliance experience
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamCredibility;
